import React from "react";

const DAY_LABELS = {
  MON: "Monday",
  TUE: "Tuesday",
  WED: "Wednesday",
  THU: "Thursday",
  FRI: "Friday",
  SAT: "Saturday",
  SUN: "Sunday",
};

const WEEK_ORDER = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

const formatTime = (time24) => {
  if (typeof time24 !== "string" || !time24.includes(":")) {
    return "";
  }

  const [hourStr, minuteStr] = time24.split(":");
  const hour24 = parseInt(hourStr, 10);

  if (Number.isNaN(hour24)) {
    return "";
  }

  const period = hour24 >= 12 ? "PM" : "AM";
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;

  return `${hour12}:${minuteStr || "00"} ${period}`;
};

const TimeSlotBadge = ({ children }) => (
  <span className="inline-flex  items-center justify-center rounded-lg bg-[#923D8C33] px-[11px] py-1 text-base leading-[19px] text-[#4A4A68]">
    {children}
  </span>
);

const UnavailableBadge = () => (
  <span className="inline-flex min-w-[157px] items-center justify-center rounded-lg bg-[#DC262633] px-4 py-1 text-base leading-[19px] text-[#DC2626]">
    Not Available
  </span>
);

const InfoIcon = () => (
  <svg width="32" height="32" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
      fill="#9CA3AF"
    />
  </svg>
);

const buildWeekSchedule = (availability) => {
  const activeSlots = Array.isArray(availability)
    ? availability.filter((slot) => slot?.isActive !== false)
    : [];

  const schedule = WEEK_ORDER.map((dayKey) => {
    const daySlots = activeSlots
      .filter(
        (slot) => Array.isArray(slot?.days) && slot.days.includes(dayKey)
      )
      .map((slot) => `${formatTime(slot?.startTime)} - ${formatTime(slot?.endTime)}`)
      .filter((slot) => slot !== " - ");

    return {
      day: DAY_LABELS[dayKey],
      slots: daySlots,
      unavailable: daySlots.length === 0,
    };
  });

  return { schedule, hasAnySlot: activeSlots.length > 0 };
};

const InstructorAvailableTimeSlots = ({ availability = [] }) => {
  const { schedule, hasAnySlot } = buildWeekSchedule(availability);

  return (
    <section className="rounded-xl border border-[#60555557] bg-white px-4 pb-3 pt-4 sm:pl-6 sm:pr-5 desktop:pl-9">
      <h3 className="text-xl font-medium leading-[23px] text-black">
        Available Time Slots
      </h3>

      {hasAnySlot ? (
        <div className="mt-3 space-y-2">
          {schedule.map(({ day, slots, unavailable }) => (
            <div
              key={day}
              className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3"
            >
              <p
                className={`text-lg leading-[23px] desktop:text-xl ${
                  unavailable ? "text-[#DC2626]" : "text-black"
                }`}
              >
                {day}
              </p>

              {unavailable ? (
                <UnavailableBadge />
              ) : (
                <div className="flex flex-wrap gap-2 sm:justify-end sm:gap-3">
                  {slots.map((slot) => (
                    <TimeSlotBadge key={`${day}-${slot}`}>{slot}</TimeSlotBadge>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-4 flex flex-col items-center justify-center gap-2 rounded-lg bg-[#F9FAFB] px-4 py-8 text-center">
          <InfoIcon />
          <p className="text-base leading-[19px] text-[#6B7280]">
            No availability slots have been added yet.
          </p>
        </div>
      )}
    </section>
  );
};

export default InstructorAvailableTimeSlots;
